import { Injectable } from '@angular/core';
import { HttpClient, HttpInterceptor, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CONFIG } from './config';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  token: any;
  headers: any;
  options: any;
  constructor(private _http: HttpClient) { }

  getToken() {
    return window.localStorage.getItem('m_ind_token');
  }
  getType() {
    return window.localStorage.getItem('m_ind_type');
  }
  authHeader(headers: Headers) {
    headers.append('x-access-token', this.getToken());
    headers.append('x-access-type', this.getType());
  }

  login<T>(url: T | any, objToCreate: T | any): Observable<T | any> {
    return this._http.post<T | T[]>(`${CONFIG.API_ENDPOINT}${url}`, objToCreate);
  }
  photoUpload<T>(url: T | any, objToCreate: T | any): Observable<T | any> {
    return this._http.post<T | T[]>(`${CONFIG.API_ENDPOINT}${url}`, objToCreate, { headers: {} });
  }

  photoUploadToken<T>(url: T | any, objToCreate: T | any): Observable<T | any> {
    const headerDict = {
      'Content-Type': 'application/json',
      'x-access-token': this.getToken(),
      'x-access-type': this.getType(),
    }

    let headers = new HttpHeaders(headerDict);
    return this._http.post<T | T[]>(`${CONFIG.API_ENDPOINT}${url}`, objToCreate, { headers: headers });
  }

  post<T>(url: T | any, objToCreate: T | any): Observable<T | any> {
    const headerDict = {
      'Content-Type': 'application/json',
      'x-access-token': this.getToken(),
      'x-access-type': this.getType(),
    }

    let headers = new HttpHeaders(headerDict);

    return this._http.post<T | T[]>(`${CONFIG.API_ENDPOINT}${url}`, objToCreate, { headers: headers });
  }

  // READ
  get<T>(url: T | any): Observable<T | any> {
    const headerDict = {
      'Content-Type': 'application/json',
      'x-access-token': this.getToken(),
      'x-access-type': this.getType(),
    }

    let headers = new HttpHeaders(headerDict);
    return this._http.get<T | T[]>(`${CONFIG.API_ENDPOINT}${url}`, { headers });
  }

  // UPDATE
  update<T>(url: T | any, objToUpdate: T | any): Observable<T | any> {
    return this._http.patch<T | T[]>(`${CONFIG.API_ENDPOINT}${url}`, objToUpdate);
  }

  // DELETE 
  delete<T>(url: T | any, objToDelete): Observable<T | any> {
    const headerDict = {
      'Content-Type': 'application/json',
      'x-access-token': this.getToken(),
      'x-access-type': this.getType(),
    }

    let headers = new HttpHeaders(headerDict);
    const options = {
      headers: headers,
      body: {
        remove: objToDelete.id
      }
    };
    return this._http.delete<T | T[]>(`${CONFIG.API_ENDPOINT}${url}`, options);
  }

}
